import { ProgressBar } from 'primeng/progressbar';

import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LoadingService } from '@presentation/shared/services/loading/loading.service';

@Component({
  selector: 'app-loading-page',
  template: `
    <section *ngIf="loading()" id="container-loading-page">
      <img
        id="logo-confear"
        src="assets/img/logos/logo-egtec-branco.png"
        alt="logo confear" />
      <p-progressBar
        [style]="{ height: '30px', width: '400px' }"
        mode="indeterminate"></p-progressBar>
    </section>
  `,
  styleUrls: ['./loading-page.component.scss'],
  standalone: true,
  imports: [ProgressBar, CommonModule]
})
export class LoadingPageComponent {
  loadingService = inject(LoadingService);
  loading = this.loadingService.listen();
}
